import type { VideoCaptionStyle, VideoVoiceoverVoice } from './videoVoiceoverCaptionsConstants'

const GEMINI_TTS_BASE = 'https://blaze-media-uploads-for-dev.s3.us-west-1.amazonaws.com/gemini3.1tts'

export const VIDEO_VOICE_PREVIEW_URLS: Record<VideoVoiceoverVoice, string> = {
  // Female
  Achernar: `${GEMINI_TTS_BASE}/gemini-tts-achernar.wav`,
  Aoede: `${GEMINI_TTS_BASE}/gemini-tts-aoede.wav`,
  Autonoe: `${GEMINI_TTS_BASE}/gemini-tts-autonoe.wav`,
  Callirrhoe: `${GEMINI_TTS_BASE}/gemini-tts-callirrhoe.wav`,
  Despina: `${GEMINI_TTS_BASE}/gemini-tts-despina.wav`,
  Erinome: `${GEMINI_TTS_BASE}/gemini-tts-erinome.wav`,
  Gacrux: `${GEMINI_TTS_BASE}/gemini-tts-gacrux.wav`,
  Kore: `${GEMINI_TTS_BASE}/gemini-tts-kore.wav`,
  Laomedeia: `${GEMINI_TTS_BASE}/gemini-tts-laomedeia.wav`,
  Leda: `${GEMINI_TTS_BASE}/gemini-tts-leda.wav`,
  Pulcherrima: `${GEMINI_TTS_BASE}/gemini-tts-pulcherrima.wav`,
  Sulafat: `${GEMINI_TTS_BASE}/gemini-tts-sulafat.wav`,
  Vindemiatrix: `${GEMINI_TTS_BASE}/gemini-tts-vindemiatrix.wav`,
  Zephyr: `${GEMINI_TTS_BASE}/gemini-tts-zephyr.wav`,
  // Male
  Achird: `${GEMINI_TTS_BASE}/gemini-tts-achird.wav`,
  Algenib: `${GEMINI_TTS_BASE}/gemini-tts-algenib.wav`,
  Algieba: `${GEMINI_TTS_BASE}/gemini-tts-algieba.wav`,
  Alnilam: `${GEMINI_TTS_BASE}/gemini-tts-alnilam.wav`,
  Charon: `${GEMINI_TTS_BASE}/gemini-tts-charon.wav`,
  Enceladus: `${GEMINI_TTS_BASE}/gemini-tts-enceladus.wav`,
  Fenrir: `${GEMINI_TTS_BASE}/gemini-tts-fenrir.wav`,
  Iapetus: `${GEMINI_TTS_BASE}/gemini-tts-iapetus.wav`,
  Orus: `${GEMINI_TTS_BASE}/gemini-tts-orus.wav`,
  Puck: `${GEMINI_TTS_BASE}/gemini-tts-puck.wav`,
  Rasalgethi: `${GEMINI_TTS_BASE}/gemini-tts-rasalgethi.wav`,
  Sadachbia: `${GEMINI_TTS_BASE}/gemini-tts-sadachbia.wav`,
  Sadaltager: `${GEMINI_TTS_BASE}/gemini-tts-sadaltager.wav`,
  Schedar: `${GEMINI_TTS_BASE}/gemini-tts-schedar.wav`,
  Umbriel: `${GEMINI_TTS_BASE}/gemini-tts-umbriel.wav`,
  Zubenelgenubi: `${GEMINI_TTS_BASE}/gemini-tts-zubenelgenubi.wav`,
}

const SUBTITLE_PREVIEW_BASE = 'https://blaze-media-uploads-for-dev.s3.us-west-1.amazonaws.com/subtitle-previews'

export const VIDEO_CAPTION_PREVIEW_URLS: Record<VideoCaptionStyle, string> = {
  simple: `${SUBTITLE_PREVIEW_BASE}/simple.png`,
  plain: `${SUBTITLE_PREVIEW_BASE}/plain.png`,
  beans: `${SUBTITLE_PREVIEW_BASE}/beans.png`,
  corpo: `${SUBTITLE_PREVIEW_BASE}/corpo.png`,
  boo: `${SUBTITLE_PREVIEW_BASE}/boo.png`,
  shadeplay: `${SUBTITLE_PREVIEW_BASE}/shadeplay.png`,
  casper: `${SUBTITLE_PREVIEW_BASE}/casper.png`,
  lowkey: `${SUBTITLE_PREVIEW_BASE}/lowkey.png`,
  vinta: `${SUBTITLE_PREVIEW_BASE}/vinta.png`,
  diego: `${SUBTITLE_PREVIEW_BASE}/diego.png`,
  ali: `${SUBTITLE_PREVIEW_BASE}/ali.png`,
  kitty: `${SUBTITLE_PREVIEW_BASE}/kitty.png`,
  hustle: `${SUBTITLE_PREVIEW_BASE}/hustle.png`,
  karl: `${SUBTITLE_PREVIEW_BASE}/karl.png`,
  sprout: `${SUBTITLE_PREVIEW_BASE}/sprout.png`,
  flex: `${SUBTITLE_PREVIEW_BASE}/flex.png`,
  mint: `${SUBTITLE_PREVIEW_BASE}/mint.png`,
  rizz: `${SUBTITLE_PREVIEW_BASE}/rizz.png`,
  vegas: `${SUBTITLE_PREVIEW_BASE}/vegas.png`,
}
